import { render, staticRenderFns } from "./IranPelakBox.vue?vue&type=template&id=9b99c5b6&"
import script from "./IranPelakBox.vue?vue&type=script&lang=js&"
export * from "./IranPelakBox.vue?vue&type=script&lang=js&"
import style0 from "./IranPelakBox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
